@if (useIncidents) {
    @if (isLoadingIncidents) {
    <div class="fancy-loader submodule"></div>
    } @else {
    <incident-linkable
        #linkableIncidents
        displayValueProp="name"
        [linked]="linkedIncidents"
        [unlinked]="[]"
        [hideActions]="true"
        [orderByValueProperty]="true"
        [disabled]="true"
    >
    </incident-linkable>
    }
}
@if (isLoading) {
    <div class="fancy-loader submodule"></div>
}
<event-linkable
    #linkable
    displayValueProp="name"
    [linked]="linked"
    [unlinked]="[]"
    [hideActions]="true"
    [orderByValueProperty]="true"
    [disabled]="true"
>
</event-linkable>
